import React, { useState } from "react";
import { Input, Button } from "antd";

interface CandidateFiltersProps {
  search: string;
  onSearchChange: (val: string) => void;
  onSearch: () => void;
  onReset: () => void;
}

const CandidateFilters: React.FC<CandidateFiltersProps> = ({
  search,
  onSearchChange,
  onSearch,
  onReset,
}) => {
  return (
    <div className="card">
      <div className="card-header border-0 pb-0">
        <div className="d-flex align-items-center justify-content-between mb-3">
          <div>
            <h4 className="mb-1 d-flex align-items-center">
              <i className="ti ti-users text-primary fs-32 me-2" />
              Candidates Directory
            </h4>
            <p className="text-muted mb-0">Monitor and manage all candidates across your company</p>
          </div>
        </div>
      </div>

      <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
        
        <div className="d-flex gap-2">
          <div className="d-flex gap-2 mb-2 me-2">
            <Input
              placeholder="Search name, email, phone..."
              value={search}
              onChange={(e) => onSearchChange(e.target.value)}
              onPressEnter={onSearch}
              style={{ width: 260, minHeight: 38 }}
              allowClear
              onClear={onReset}
            />
            <Button type="primary" onClick={onSearch} style={{ minHeight: 38 }}>
              <i className="ti ti-search me-1" />
            </Button>
          </div>
        </div>

        
        <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
          <div>
            <button
              type="button"
              className={`btn btn-md ${search ? "btn-warning" : "btn-outline-danger"} mb-2 position-relative py-2`}
              onClick={onReset}
            >
              <i className="ti ti-refresh me-1" />
              Reset
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CandidateFilters;
